var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 130,
    viewBox: "0 0 116 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9593 68.7658C52.9593 89.1221 52.9593 109.644 52.9593 130C36.4095 120.236 19.6942 110.637 2.97896 101.038C1.15848 100.045 0 98.0589 0 96.073C0 76.7097 0 57.512 0 38.1488C17.7083 48.2441 35.4165 58.505 52.9593 68.7658Z",
    fill: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.683 38.1488C115.683 57.512 115.683 76.7097 115.683 96.073C115.683 98.0589 114.524 100.045 112.704 101.038C95.9887 110.637 79.2734 120.401 62.5581 130C62.5581 109.644 62.5581 89.1221 62.5581 68.7658C80.2664 58.505 97.9747 48.2441 115.683 38.1488Z",
    fill: "#003393",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.881 29.7068C93.1727 39.9677 75.4645 50.0631 57.9217 60.3239C40.2135 50.0631 22.5052 39.9677 4.96243 29.7068C21.5122 20.108 38.2275 10.5091 54.9428 0.74474C56.7632 -0.248247 58.9147 -0.248247 60.7352 0.74474C77.4504 10.5091 94.1657 20.108 110.881 29.7068Z",
    fill: "#003393",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.dacbdb44fdcbbfa6f6f3354358868c1d.svg";
export { ForwardRef as ReactComponent };